export const textarea = {
  colorScheme: {
    light: {
      color: '{neutral.900}',
      root: {},
      background: '{surface.100}',
      borderColor: '{surface.600}',
    },
    dark: {
      background: '#333643',
      color: 'white',
      borderColor: '#5B5F69',
      disabled: {
        background: '#333643',
        color: 'white',
        borderColor: '#5B5F69',
        opacity: '0.8',
      },
      root: {
        focusBorderColor: 'var(--p-primary-color)',
        hoverBorderColor: 'var(--p-primary-color)',
        color: 'white',
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
.p-textarea:focus, .p-textarea:focus-visible {
outline: none !important;
box-shadow: none !important;
border-color: ${dt('textarea.colorScheme.dark.borderColor')};
}
`,
};
